import { Link } from 'react-router-dom';

interface Comic {
  id: number;
  slug: string;
  title: string;
  cover: string;
  rating: number;
  views: string;
  updateTime: string;
  tags: string[];
}

interface Props {
  latestComics: Comic[];
}

const cardColors = [
  { bg: '#f5e6e0', tag: '#e8c4b8' },
  { bg: '#e0ece4', tag: '#b8d4c0' },
  { bg: '#e8e5e0', tag: '#d0cbc4' },
  { bg: '#e8dfd5', tag: '#d4c4b0' },
];

export default function LatestUpdateSection({ latestComics }: Props) {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Title area */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
          <div>
            <span className="text-xs md:text-sm text-foreground-400 uppercase tracking-wider" style={{ fontFamily: "var(--font-heading)" }}>
              每日更新
            </span>
            <div className="flex flex-col mt-2">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-none" style={{ fontFamily: "var(--font-heading)" }}>
                最新上架
              </h2>
              <span className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-300 italic mt-1" style={{ fontFamily: "'Caveat', cursive" }}>
                韩国漫画
              </span>
            </div>
          </div>
          <Link
            to="/category/hanman"
            className="mt-4 md:mt-0 inline-flex items-center gap-1.5 text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>

        {/* 4-column card grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {latestComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.slug}`}
              className="group cursor-pointer"
            >
              <div
                className="relative rounded-xl overflow-hidden transition-all duration-300 group-hover:scale-[1.02]"
                style={{ backgroundColor: cardColors[index % 4].bg }}
              >
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </div>
              <div className="mt-3 px-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                  {comic.title}
                </h3>
                <div className="flex items-center justify-between mt-1.5">
                  <div className="flex items-center gap-1.5">
                    <i className="ri-star-fill text-accent-500 text-xs w-3 h-3 flex items-center justify-center"></i>
                    <span className="text-xs text-foreground-600">{comic.rating}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{comic.updateTime}</span>
                </div>
                <div className="flex gap-1.5 mt-2 flex-wrap">
                  {comic.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 rounded-full text-xs whitespace-nowrap"
                      style={{ backgroundColor: cardColors[index % 4].tag, color: '#5a4a3a' }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}